import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get("/users", config),
    create: (data: object, config: AxiosRequestConfig) =>
        api.post("/users", data, config),
    delete: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/users/${url.id}`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/users/${url.id}`, config),
    email: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/users/exists/${url.id}`, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/users/${url.id}`, data, config),
};

export default requests;
